import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section brand-section">
            <div className="footer-brand">
              <div className="footer-logo-text">
                <span className="footer-logo-pandemic">Pandemic</span>
                <span className="footer-logo-relief">Relief</span>
                <span className="footer-logo-connect">Connect</span>
              </div>
            </div>
            <p className="brand-description">
              Connecting communities during crisis. Facilitating safe donation collection 
              and distribution to help those in need during pandemic situations and emergency relief efforts.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-link">
                <i className="fa fa-facebook"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="social-link">
                <i className="fa fa-twitter"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-link">
                <i className="fa fa-instagram"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-link">
                <i className="fa fa-linkedin"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/donate">Start Donating</Link></li>
              <li><Link to="/dev-status">Development Status</Link></li>
              <li><a href="#features">How We Work</a></li>
              <li><a href="#about">About Us</a></li>
            </ul>
          </div>

          {/* Donation Categories */}
          <div className="footer-section">
            <h4>Donation Categories</h4>
            <ul className="footer-links">
              <li><a href="#medical">Medical Supplies</a></li>
              <li><a href="#food">Food & Groceries</a></li>
              <li><a href="#clothing">Clothing & Essentials</a></li>
              <li><a href="#electronics">Electronics</a></li>
              <li><a href="#household">Household Items</a></li>
            </ul>
          </div>

          {/* Contact & Support */}
          <div className="footer-section">
            <h4>Contact & Support</h4>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fa fa-envelope"></i>
                <span>support@covid19relief.org</span>
              </div>
              <div className="contact-item">
                <i className="fa fa-phone"></i>
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="contact-item">
                <i className="fa fa-map-marker"></i>
                <span>Emergency Helpline 24/7</span>
              </div>
            </div>
            <div className="emergency-notice">
              <p><strong>Emergency?</strong> Call local authorities first!</p>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} Pandemic Relief Connect. Built for community relief efforts.</p>
            </div>
            <div className="footer-meta">
              <span className="tech-info">
                Built with React {React.version} | 
                <Link to="/dev-status" className="dev-link"> View Tech Stack</Link>
              </span>
            </div>
          </div>
          <div className="footer-legal">
            <a href="#privacy">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="#terms">Terms of Service</a>
            <span className="separator">|</span>
            <a href="#cookies">Cookie Policy</a>
            <span className="separator">|</span>
            <a href="#accessibility">Accessibility</a>
          </div>
        </div>

        {/* Development Notice */}
        <div className="dev-notice">
          <div className="dev-notice-content">
            <i className="fa fa-code"></i>
            <span>
              This platform is in active development. 
              <Link to="/dev-status" className="dev-status-link"> Check development status</Link> 
              for latest updates and features.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
